import { Info } from 'lucide-react'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import useTranslator from '@/hooks/translation'

const SupersetIdInfo = () => {
  const { getTranslation } = useTranslator()
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <Info className="h-4 w-4" />
      </TooltipTrigger>

      <TooltipContent
        side="top"
        align="start"
        sideOffset={0}
        className="max-w-72 text-xs"
      >
        {getTranslation('dashboards.edit.form.supersetId.info')}
      </TooltipContent>
    </Tooltip>
  )
}

export { SupersetIdInfo }
